import React from "react";
import SectionHeader from "./SectionHeader";
import Input from "../util/Input";
import { Text } from "@kui/foundations-react";
import { PropTypes } from "prop-types";

const Entitlement = props => {
  const fe = props.fieldErrors || {};
  // "OR" only separates the two fields when both are shown (not in the warranty page)
  const showOr = props.showSerial && !props.isWarranty;
  return (
    <div className='AppSection regSection'>
      <SectionHeader title={"Entitlement"} showHr={false} />
      <div className={showOr ? 'regRow regRow--or' : 'regRow'}>
        {!props.isWarranty && (
          <Input
            labelText='PAK ID/Entitlement ID'
            placeholder='Enter PAK ID or entitlement ID'
            type='text'
            value={props.pakId}
            readOnly={!props.allowPakIdEdit}
            onChange={props.onPakIdChange}
            isRequired={false}
            onBlur={props.onPakIdBlur}
            errorText={fe.entitlement}
            maximumLength={35}
          />
        )}
        {showOr && (
          <Text kind='label/regular/md' className='regOr'>OR</Text>
        )}
        {props.showSerial && (
          <Input
            labelText='Serial Number'
            placeholder='Enter serial number'
            type='text'
            value={props.serial}
            onChange={props.onSerialChange}
            readOnly={!props.allowSerialEdit}
            isRequired={false}
            onBlur={props.onSerialBlur}
            errorText={props.isWarranty ? fe.entitlement : undefined}
            maximumLength={18}
          />
        )}
      </div>
    </div>
  );
};

Entitlement.propTypes = {
  showSerial: PropTypes.bool.isRequired,
  pakId: PropTypes.string,
  serial: PropTypes.string,
  allowPakIdEdit: PropTypes.bool.isRequired,
  allowSerialEdit: PropTypes.bool.isRequired,
  onPakIdChange: PropTypes.func.isRequired,
  onSerialChange: PropTypes.func.isRequired,
  onPakIdBlur: PropTypes.func.isRequired,
  onSerialBlur: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object
};

export default Entitlement;
